/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface AssetStopEventOffsetEUMarker {
  width?: number,
  height?: number,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with offset for stop(destination) of the trip
 *
 * ```typescript
 *  import {getAssetStopEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getAssetStopEventOffsetEUMarker({fillColor, width, height}),
 *    width  : width,
 *    height : height
 * }
 * ```
 */
export const getAssetStopEventOffsetEUMarker = ({
  fillColor = dlsColor('grey4'),
  width = 50,
  height = 51
}: AssetStopEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 50 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.5 13.25C17.4371 13.25 22.25 18.0629 22.25 24C22.25 25.5511 21.5638 27.6177 20.624 29.7568C19.6707 31.9267 18.4051 34.2809 17.1484 36.4473C15.8903 38.6162 14.6334 40.6101 13.6914 42.0605C13.2203 42.7859 12.8271 43.3767 12.5518 43.7861C12.4142 43.9907 12.3055 44.1502 12.2314 44.2588C12.1946 44.3129 12.1668 44.3547 12.1475 44.3828C12.1378 44.3969 12.13 44.4078 12.125 44.415C12.1226 44.4185 12.1204 44.421 12.1191 44.4229C12.1185 44.4238 12.1185 44.4253 12.1182 44.4258H12.1172L11.5 45.3193L10.8828 44.4258H10.8818C10.8815 44.4253 10.8815 44.4238 10.8809 44.4229C10.8796 44.421 10.8774 44.4185 10.875 44.415C10.87 44.4078 10.8622 44.3969 10.8525 44.3828C10.8332 44.3547 10.8054 44.3129 10.7686 44.2588C10.6945 44.1502 10.5858 43.9907 10.4482 43.7861C10.1729 43.3767 9.7797 42.7859 9.30859 42.0605C8.36662 40.6101 7.10973 38.6162 5.85156 36.4473C4.59485 34.2809 3.32931 31.9267 2.37598 29.7568C1.43616 27.6177 0.75 25.5511 0.75 24C0.75 18.0629 5.56294 13.25 11.5 13.25Z' fill='${fillColor}' stroke='white' stroke-width='1.5'/>
      <circle cx='11.5' cy='24' r='5' fill='white'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getAssetStopEventOffsetEUMarker;
